import { render, staticRenderFns } from "./common-balance.vue?vue&type=template&id=f4c64900&"
import script from "./common-balance.vue?vue&type=script&lang=js&"
export * from "./common-balance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports